export enum PageStatus {
  idle = 'idle',
  loading = 'loading',
  success = 'success',
  error = 'error',
}
